
import {first} from 'rxjs/operators';
import { AccountService, Account } from '../../../../shared';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, OnInit, Injector, Input, AfterViewChecked } from '@angular/core';

import { SectionState } from '../../../../shared/components/section/section.model';
import { BaseControlValueAccessor } from '../../../../shared/core/base-control-value-accessor';
import { PartieDepot, QualityType, RequeteCategory } from '../../../../entities/requete';
import { SearchForm } from './search-form/search-form.model';
import { UserService, ScrollToService } from '../../../../shared';
import { isEquals } from '../../../../shared/core/util';

export enum RequerantsHandlingError {
    NotFound, AlreadyAdded, Mandataire
}

export enum ScrollSelector {
    ERROR = '.error',
    ADDED_REQUERANTS = 'jhi-added-requerant'
}

@Component({
  selector: 'jhi-add-requerant-section',
  templateUrl: './add-requerant-section.component.html',
  styleUrls: ['./add-requerant-section.component.scss'],
  providers: [
    {
        provide: NG_VALUE_ACCESSOR,
        useExisting: AddRequerantSectionComponent,
        multi: true
    }]
})
export class AddRequerantSectionComponent extends BaseControlValueAccessor implements OnInit, AfterViewChecked {

    @Input()
    requeteCategory: RequeteCategory;
    RequeteCategoryEnum = RequeteCategory;

    @Input()
    state: SectionState;

    requerant: PartieDepot;
    addedRequerants: Array<PartieDepot>;

    errorType: RequerantsHandlingError;
    RequerantsHandlingErrorEnum = RequerantsHandlingError;

    mandataire: Account;

    scrollSelector: ScrollSelector;

    constructor(injector: Injector,
        private accountService: AccountService,
        private scrollService: ScrollToService,
        private userService: UserService) {
        super(injector);
        this.addedRequerants = [];
    }

    ngOnInit(): void {
        this.userService.getAccount(false)
            .then(account => this.mandataire = account );
    }

    ngAfterViewChecked(): void {
        if (this.scrollSelector) {
            this.scrollService.scrollBySelector(this.scrollSelector);
            this.scrollSelector = null;
        }
    }

    protected modelValueChanged(value: any): void {
        this.addedRequerants = value;
        this.errorType = null;
    }

    setRequerants(value: any) {
        this.onChange(value);
    }

    search(searchForm: SearchForm) {
        this.errorType = null;
        if (searchForm != null) {
            this.accountService.getRequerant(searchForm.email, searchForm.firstName, searchForm.lastName).pipe(first())
            .subscribe(account => {
                if (this.isAccountAlreadyAdded(account)) {
                    this.errorType = RequerantsHandlingError.AlreadyAdded;
                } else if (this.isMandataire(account)) {
                    this.errorType = RequerantsHandlingError.Mandataire;
                } else {
                    this.requerant = this.setRequerantFromAccount(account);
                }
            }, () => {
                this.errorType = RequerantsHandlingError.NotFound;
            });
        }
    }

    isMandataire(account: Account): boolean {
        return this.mandataire.id === account.id;
    }

    isAccountAlreadyAdded(account: Account): boolean {
        return this.addedRequerants.some(item => item.userId === account.id);
    }

    setRequerantFromAccount(account: Account): PartieDepot {
        const requerant = this.accountService.mapAccountToPartieDepot(account);
        requerant.qualite = QualityType.Requerant;
        return requerant;
    }

    addQualifiedRequerant() {
        this.addedRequerants.push(this.requerant);
        this.requerant = null;
        this.setRequerants(this.addedRequerants);
    }

    addAnonymousRequerant(requerant: PartieDepot) {
        this.errorType = null;
        if (!this.isRequerantAlreadyAdded(requerant)) {
            this.addedRequerants.push(requerant);
            this.setRequerants(this.addedRequerants);
            this.scrollSelector = ScrollSelector.ADDED_REQUERANTS;
        } else {
            this.errorType = RequerantsHandlingError.AlreadyAdded;
            this.scrollSelector = ScrollSelector.ERROR;
        }
    }

    isRequerantAlreadyAdded(partie: PartieDepot): boolean {
        return this.addedRequerants.some(item => isEquals(item, partie));
    }

    removeRequerant(index: number) {
        this.addedRequerants.splice(index, 1);
        this.setRequerants(this.addedRequerants);
        this.errorType = null;
    }

    moveToRequerantPrincipal(index: number) {
        this.swap(0, index);
        this.setRequerants(this.addedRequerants);
    }

    private swap(x: number, y: number) {
        const tmp = this.addedRequerants[x];
        this.addedRequerants[x] = this.addedRequerants[y];
        this.addedRequerants[y] = tmp;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/requerants/add-requerant-section/add-requerant-section.component.ts